import {breakpoints} from '../constants/breakpoints';
import STATE from '../constants/state';

const handleMobileNav = () => {
  const selectors = {
    menu: '.js-menu-mobile',
    hamburger: '.js-menu-hamburger',
    logo: '.js-nav-logo',
  };

  const menu = document.querySelector(selectors.menu);
  const hamburger = document.querySelector(selectors.hamburger);
  const logo = document.querySelector(selectors.logo);

  hamburger.addEventListener('click', () => {
    menu.classList.toggle(STATE.active);
    hamburger.classList.toggle(STATE.active);
    document.body.classList.toggle('ui-overflow');
    logo.classList.toggle('l-header__logo--dark');
  });

  window.addEventListener('resize', () => {
    const windowWidth = window.innerWidth;

    if (windowWidth > breakpoints['tablet']) {
      menu.classList.remove(STATE.active);
      hamburger.classList.remove(STATE.active);
      document.body.classList.remove('ui-overflow');
      logo.classList.remove('l-header__logo--dark');
    }
  });
  window.addEventListener('hashchange', function () {
    menu.classList.remove(STATE.active);
    hamburger.classList.remove(STATE.active);
    document.body.classList.remove('ui-overflow');
    logo.classList.remove('l-header__logo--dark');
  });
};

export default handleMobileNav;
